import React from "react";
import notification from "../../assets/images/page_icons/Notifications.png";
import observationIcon from "../../assets/images/page_icons/Observations.png";
import updateIcon from "../../assets/images/page_icons/Updates.png";
import notificationCloseIcon from "../../assets/SVGs/notification-closs-icon.svg";
import closeimg from "../../assets/images/close.png";
import time from "../../assets/images/time11.png";

import "./mainDashboard.css";
import "./notification.css";

export const DashboardNotificationSection = ({
  theme,
  setOpenNotificationContainer,
}) => {
  const notifications = [
    {
      id: 1,
      name: "Your account balance is low..",
      value: "59 minutes ago",
    },
    {
      id: 1,
      name: "Your account balance is low...",
      value: "12 hours ago",
    },
    { id: 1, name: "Your account balance is low...", value: "Just now" },
    {
      id: 1,
      name: "Your Credit Score is ready...",
      value: "Today, 11:59 AM",
    },
  ];

  const Updates = [
    {
      id: 1,
      name: "Asset Planet has added new Asset......",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "You earned another monthly reward!...",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "Asset Planet improved the Collectibles app...",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "Asset Planet completed your request...",
      value: "27 March 2020, at 12:30 PM",
    },
  ];
  const observation = [
    {
      id: 1,
      name: "Based on your net worth, consider an umbrella...",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "Your Capital One credit card has a promotion...",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "Your Collection of Autographs has jumped.... ",
      value: "27 March 2020, at 12:30 PM",
    },
    {
      id: 1,
      name: "Your Trust does not appear to have been...",
      value: "27 March 2020, at 12:30 PM",
    },
  ];
  return (
    <React.Fragment>
      <div className="NotificationMain1">
        <div
          onClick={() => {
            setOpenNotificationContainer(false);
          }}
          className="notification-close-container">
          <img src={notificationCloseIcon} alt="notificationCloseIcon" />
        </div>
        <div className="NotificationMainsectioncard">
          <h3
            className="NotificationSubCardheading"
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}>
            Notifications
          </h3>
          {notifications &&
            notifications.map((item, index) => (
              <div key={index} className="NotificationMaincardsInner">
                {" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    width: "100%",
                    justifyContent: "space-between",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      gap: "4px",
                    }}>
                    <img
                      src={notification}
                      height={"25px"}
                      style={{
                        marginTop: "6px",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                      }}
                      alt={"new"}
                    />{" "}
                    <div className="generalMainHeader">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#ffffff",
                        }}
                        className="notificationgerealheading">
                        {item.name.substring(0, 35) + ".."}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#dedede",
                        }}
                        className="notificationDetails">
                        {item.value.substring(0, 35) + ".."}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}>
                    <img src={time} height={"15px"} alt={"new"} />
                    <img src={closeimg} height={"15px"} alt={"new"} />{" "}
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className="NotificationMainsectioncard">
          <h3
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}
            className="NotificationSubCardheading">
            Updates
          </h3>
          {Updates &&
            Updates.map((item, index) => (
              <div key={index} className="NotificationMaincardsInner">
                {" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    width: "100%",
                    justifyContent: "space-between",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      gap: "4px",
                    }}>
                    <img
                      src={notification}
                      height={"25px"}
                      style={{
                        marginTop: "6px",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                      }}
                      alt={"new"}
                    />
                    <div className="generalMainHeader">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#ffffff",
                        }}
                        className="notificationgerealheading">
                        {item.name.substring(0, 35) + ".."}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#dedede",
                        }}
                        className="notificationDetails">
                        {item.value.substring(0, 35) + ".."}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}>
                    <img src={closeimg} height={"15px"} alt={"new"} />{" "}
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="NotificationMainsectioncard">
          <h3
            style={{
              color: theme === "light" ? "#232323" : "#ffffff",
            }}
            className="NotificationSubCardheading">
            Observations
          </h3>
          {observation &&
            observation.map((item, index) => (
              <div key={index} className="NotificationMaincardsInner">
                {" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    width: "100%",
                    justifyContent: "space-between",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      gap: "4px",
                    }}>
                    <img
                      src={notification}
                      height={"25px"}
                      style={{
                        marginTop: "6px",
                        filter: theme === "dark" ? "invert(1)" : "invert(0)",
                      }}
                      alt={"new"}
                    />
                    <div className="generalMainHeader">
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#ffffff",
                        }}
                        className="notificationgerealheading">
                        {item.name.substring(0, 35) + ".."}
                      </span>
                      <span
                        style={{
                          color: theme === "light" ? "#232323" : "#dedede",
                        }}
                        className="notificationDetails">
                        {item.value.substring(0, 35) + ".."}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}>
                    <img src={closeimg} height={"15px"} alt={"new"} />{" "}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};
